import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../context/authContext";
import useSubscriptionService from "../services/subscriptionService";
import { SepaSuccessNotification } from "./SepaNotification";

const ProtectedRoute = ({ children, subscriptionRequired = true }) => {
  const { isAuthenticated, loading } = useAuth();
  const { getUserSubscription } = useSubscriptionService();
  const [checking, setChecking] = useState(true);
  const [allow, setAllow] = useState(false);
  const [showSepaSuccess, setShowSepaSuccess] = useState(false); // NEU
  const navigate = useNavigate();

  useEffect(() => {
    const verify = async () => {
      if (!isAuthenticated) {
        navigate("/login");
        return;
      }

      if (!subscriptionRequired) {
        setAllow(true);
        setChecking(false);
        return;
      }

      const status = await getUserSubscription();
      if (status === "active" || status === "incomplete") {
        setAllow(true);

        // NEU: Prüfen ob von Checkout gekommen
        const urlParams = new URLSearchParams(window.location.search);
        const fromCheckout = urlParams.get("payment");
        const sessionId = urlParams.get("session_id");

        if (fromCheckout === "checkout_complete" && sessionId) {
          setShowSepaSuccess(true);
          // URL Parameter nach Anzeige entfernen
          window.history.replaceState(
            {},
            document.title,
            window.location.pathname
          );
        }
      }
      setChecking(false);
    };

    if (!loading) {
      verify();
    }
  }, [isAuthenticated, subscriptionRequired, loading]);

  if (loading || checking) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-white">
        <div className="animate-spin rounded-full h-16 w-16 border-4 border-gray-200 border-t-orange-500"></div>
        <p className="text-orange-500 mt-4">Loading...</p>
      </div>
    );
  }

  if (!allow) {
    return <Navigate to="/dashboard/abo" />;
  }

  return (
    <>
      {children}
      {showSepaSuccess && <SepaSuccessNotification />}
    </>
  );
};

export default ProtectedRoute;
